import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { Link } from 'react-router-dom';
import '../../styles/assets.css'
import { useUser } from '../../utils/userContext';
import useHandleErrors from '../../utils/user.utils';
import { toast, ToastContainer } from 'react-toastify';
import { utils, write } from 'xlsx';
import Select from 'react-select';
import jsPDF from 'jspdf';
import wwImg from '../../assets/globalImgs/WW-360-Logo.png'


const RequestStatus = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [modalData, setModalData] = useState(null);
    const [updateModalData, setUpdateModalData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileData, setFileData] = useState([]);
    const [file, setFile] = useState(null);
    const { user } = useUser();
    const handleErrors = useHandleErrors();
    const [searchQuery, setSearchQuery] = useState('');
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const hasFetchedRef = useRef(false);
    const [employees, setEmployees] = useState([]);
    const [updateData, setUpdateData] = useState({
        AssignTo: '',
        Comments: '',
        Document: null,
    });


    useEffect(() => {
        const fetchSupportRequests = async () => {
            if (user && user?.EmployeeId) {
                const path = `/getSupportAndRequests?employeeId=${user?.EmployeeId}`;
                const URL = process.env.REACT_APP_BE_URL + path;
                try {
                    const response = await axios.get(URL, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    if (response.status === 200) {
                        setData(response.data.supportRequests);
                        setFilteredData(response.data.supportRequests); // Assuming you want to filter the merged data
                    } else {
                        handleErrors(response);
                    }
                } catch (error) {
                    if (error.response) {
                        if (error.response.status === 404) {
                            setData([]); // Set data to an empty array
                        } else {
                            handleErrors(error.response);
                        }
                    } else {
                        toast.error("Something went wrong. Please try again later.", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    }
                }
            }
        };

        if (!hasFetchedRef.current) {
            fetchSupportRequests();
            fetchEmployees();
            hasFetchedRef.current = true;
        }
    }, [user]);


    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'RequestStatus');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Request_Status_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Assigned Asset List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Assets');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(data, `WW360-Request_Status_Report_${formattedDate}.xlsx`);
    };

    const shareData = {
        title: 'Claim List',
        text: 'Check out the Claim list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);


    const handleUpdateChange = (field) => (event) => {
        setUpdateData({ ...updateData, [field]: event.target.value });
    };

    useEffect(() => {
        // Filter employees based on the search query
        setFilteredData(
            data?.filter(data =>
                data.requestId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.department.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.assignTo.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.status.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, data]);


    const handleFileChange = (e) => {
        setUpdateData({ ...updateData, Document: e.target.files[0] });
        setFile(e.target.files[0]);
    };

    const handleDelete = (fileIndex) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, index) => index !== fileIndex));
        setFileData((prevData) => prevData.filter((_, index) => index !== fileIndex));
    };

    const handleUpload = () => {
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const binaryData = e.target.result;
                setUploadedFiles((prevFiles) => [...prevFiles, file]);
                setFileData((prevData) => [...prevData, binaryData]);
                setFile(null);
            };
            reader.readAsBinaryString(file);
        }
    };

    const handleSubmit = async () => {
        const formData = new FormData();
        setLoading(true);
        formData.append('employeeID', updateModalData.employeeId);
        formData.append('requestID', updateModalData.requestId);
        formData.append('assignto', updateData.AssignTo);
        formData.append('comments', updateData.Comments);
        formData.append('status', "new");
        uploadedFiles.forEach((file, index) => {
            formData.append('SupportRequestDocument', new Blob([fileData[index]], { type: file.type }), file.name);
        });

        try {
            const path = "/updateSupportAndRequest";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.put(URL, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.status === 200) {
                setModalData(null);
                toast.success("Request Updated successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setUpdateData({ AssignTo: "", Comments: "", Document: "" })
                setUploadedFiles([])
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const openUpdateModel = (item) => {
        setUpdateModalData(item);
    };

    const openModal = (item) => {
        setModalData(item);
    };

    const closeModal = () => {
        setModalData(false);
        setUpdateModalData(null)
        setUpdateData({ AssignTo: "", Comments: "", Document: "" })
        setFileData([])
        setUploadedFiles([])
    };

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const activeEmployees = response.data.onboardEmployeeDetails.filter(emp => emp.Status === 'Active');
                setEmployees(activeEmployees);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const assignToOptions = employees.map((emp) => ({
        value: emp.OfficialEmail,
        label: `${emp.OfficialEmail}`,
    }));

    const ClearIndicator = () => null;

    // pagination
    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData?.length / recordsPerPage);
    const paginate = pageNumber => setCurrentPage(pageNumber);
    // pagination end

    const handleDownloadPDF = (record) => {
        const doc = new jsPDF();

        // Define page margins and dimensions
        const marginLeft = 10;
        const marginRight = 10;
        const pageWidth = doc.internal.pageSize.width;

        // Header
        // Add logo on the left side
        const imgData = wwImg; // Replace with your actual logo path or base64 string
        doc.addImage(imgData, 'PNG', marginLeft, 10, 40, 15); // Logo positioned on the left

        // Add timestamp on the right side in small size
        const timestamp = new Date().toLocaleString();
        doc.setFontSize(8);
        doc.text(timestamp, pageWidth - marginRight, 15, { align: 'right' });

        // Add heading
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(37, 183, 64); // Set text color to #25b740 (RGB: 37, 183, 64)
        doc.text("Support & Request Form", pageWidth / 2, 30, { align: 'center' });

        // Reset text color to black for other text
        doc.setTextColor(0, 0, 0);

        // Add employee details
        doc.setFontSize(10);
        doc.setFont("helvetica", "Bold");
        doc.setTextColor(0, 79, 124); // Set text color to #004f7c (RGB: 0, 79, 124)
        const employeeDetailsStartY = 45; // Start Y position for employee details
        doc.text("Employee Details", marginLeft, employeeDetailsStartY);
        doc.setTextColor(0, 0, 0);
        // Employee details
        const employeeDetails = [
            { label: 'Employee ID', value: record.employeeId },
        ];

        // Draw employee details
        employeeDetails.forEach((detail, index) => {
            const y = employeeDetailsStartY + 10 + (index * 10);
            doc.text(`${detail.label}: ${detail.value}`, marginLeft, y);
        });

        // Draw a thin line above the table
        const lineY = employeeDetailsStartY + 10 + (employeeDetails.length * 10) + 5;
        doc.setDrawColor(0, 0, 0);
        // doc.setLineWidth(0.5); // Standard line width
        doc.line(marginLeft, lineY, pageWidth - marginRight, lineY);

        // Add "Details" heading
        const detailsHeadingY = lineY + 10; // Y position for "Details" heading
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 79, 124); // Set text color to #004f7c (RGB: 0, 79, 124)
        doc.text("Support & Request Details", marginLeft, detailsHeadingY);

        // Define table headers
        const headers = ['Field', 'Value'];
        doc.setTextColor(0, 0, 0);
        const rows = [
            { key: 'Request Id', value: `${record.requestId}` },
            { key: 'Employee Id', value: `${record.employeeId}` },
            { key: 'Employee Name', value: `${record.employeeName}` },
            { key: 'Category', value: `${record.category}` },
            { key: 'SubCategory', value: `${record.subCategory}` },
            { key: 'Department', value: `${record.department}` },
            { key: 'Requested Date', value: moment(`${record.requestedDate}`).format("DD-MM-YYYY") },
            { key: 'Assign To', value: `${record.assignTo}` },
            { key: 'Status', value: `${record.status}` },
        ];

        // Define table positions and dimensions
        const tableStartY = detailsHeadingY + 20; // Add space below "Details" heading
        const rowHeight = 10;
        const columnWidth = {
            field: 80,
            value: pageWidth - 100 // Adjust as needed to fit the page width
        };

        // Draw table headers (Field and Value)
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.setDrawColor(0, 0, 0);
        // doc.setLineWidth(0.5); // Normal line width

        // Draw header cell borders
        doc.rect(marginLeft, tableStartY - rowHeight, columnWidth.field, rowHeight); // Field header cell border
        doc.rect(marginLeft + columnWidth.field, tableStartY - rowHeight, columnWidth.value, rowHeight); // Value header cell border

        // Add header text
        doc.text(headers[0], marginLeft + 5, tableStartY - rowHeight / 2 + 3); // "Field" header text
        doc.text(headers[1], marginLeft + columnWidth.field + 5, tableStartY - rowHeight / 2 + 3); // "Value" header text

        // Reset font to normal for table data rows
        doc.setFont("helvetica", "normal");

        // Draw table rows
        rows.forEach((row, index) => {
            const y = tableStartY + (index * rowHeight) + rowHeight / 2; // Adjusted to center the text vertically
            doc.text(row.key, marginLeft + 5, y); // Field value
            doc.text(row.value, marginLeft + columnWidth.field + 5, y); // Value (left-aligned)

            // Draw row borders
            doc.setDrawColor(0, 0, 0);
            doc.rect(marginLeft, y - rowHeight / 2, columnWidth.field, rowHeight); // Row border for Field
            doc.rect(marginLeft + columnWidth.field, y - rowHeight / 2, columnWidth.value, rowHeight); // Row border for Value
        });

        // Add "Approved By" and "Name" text
        const approvedByY = tableStartY + (rows.length * rowHeight) + 20; // Position below the table
        const nameText = `${record.assignTo}`;
        const approvedByText = "Approved By";

        // Add the text aligned to the right side
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        // "Name" text
        doc.text(nameText, pageWidth - marginRight - 50, approvedByY); // Adjust -50 to move it closer or further from the right

        // "Approved By" text below "Name"
        doc.text(approvedByText, pageWidth - marginRight - 50, approvedByY + 10); // 10 units below "Name"

        // Add footer with timestamp and additional data, aligned left and right
        doc.setFontSize(10);
        const footerTimestamp = `Timestamp: ${timestamp}`;
        const footerText = "Generated By WorkWise360";
        doc.text(footerTimestamp, marginLeft, 280); // Left-aligned footer
        doc.text(footerText, pageWidth - marginRight, 280, { align: 'right' }); // Right-aligned footer


        // Save the PDF
        doc.save(`Support_Request_${record.requestId}.pdf`);
    };

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Support & Request</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={'/Complaint'} className="btn btn-primary mt-lg-0 mt-4">
                                <i className="ri-add-circle-line"></i> Complaint and Feedback
                            </Link>
                        </div>
                    </div>
                    {data?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row align-items-center justify-content-center">
                                <div className="col-5">
                                    <div class="input-group mb-0">
                                        <input
                                            type="search"
                                            className="form-control search-input"
                                            placeholder="Keyword search..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" title="Search" rel="tooltip"><i class="ri-menu-search-line"></i></button>
                                        </div>
                                    </div>
                                    <small className="form-text text-muted text-center mt-0">
                                        <i className="ri-information-2-line"></i> Allows IDs -Request ID- Category - Department - Assigned To - Status
                                    </small>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <h5 className="title mt-1 mb-0">Request Status</h5>
                                </div>
                                <div className="col-auto">
                                    <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                        <i className="ri-mail-send-fill"></i>
                                    </button>
                                    <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                        <i className="ri-share-fill"></i>
                                    </button>
                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                        <i className="ri-export-fill"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="table-responsive asset-information">
                                        <table className="table grid">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Request ID  </th>
                                                    <th>Emp ID  </th>
                                                    <th>Emp Name  </th>
                                                    <th>Category  </th>
                                                    {/* <th>Department  </th> */}
                                                    <th>Assigned To  </th>
                                                    <th>Request Date </th>
                                                    <th>Status </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentRecords?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                        <td>{item.requestId}</td>
                                                        <td>{item.employeeId}</td>
                                                        <td>{item.employeeName}</td>
                                                        <td>{item.category}</td>
                                                        {/* <td>{item.department}</td> */}
                                                        <td>{item.assignTo}</td>
                                                        <td>{moment(item.requestedDate).format("DD-MM-YYYY")}</td>
                                                        <td>
                                                            {item.status.trim().toLowerCase() === 'approved' ? (
                                                                <span className="badge border border-success text-success status">
                                                                    <i className="ri-thumb-up-fill"></i> {item.status.trim()}
                                                                </span>
                                                            ) : item.status.trim().toLowerCase() === 'rejected' ? (
                                                                <span className="badge border border-danger text-danger status">
                                                                    <i className="ri-thumb-down-line"></i> {item.status.trim()}
                                                                </span>
                                                            ) : item.status.trim().toLowerCase() === 'inprogress' ? (
                                                                <span className="badge border border-warning text-warning status">
                                                                    <i className="ri-hourglass-fill"></i> {item.status.trim()}
                                                                </span>
                                                            ) : (
                                                                <span className="badge border border-secondary text-secondary status">
                                                                    <i className="ri-thumb-up-fill"></i> {item.status.trim()}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {item.status.toLowerCase() === 'new' ? (
                                                                <button
                                                                    className="btn btn-link text-info btn-action"
                                                                    type="button"
                                                                    title="List View"
                                                                    onClick={() => openUpdateModel(item)}
                                                                >
                                                                    <i className="ri-list-settings-line"></i>
                                                                </button>
                                                            ) : (
                                                                <>
                                                                    <button
                                                                        className="btn btn-link text-info btn-action"
                                                                        type="button"
                                                                        title="List View"
                                                                        onClick={() => openModal(item)}
                                                                    >
                                                                        <i className="ri-layout-horizontal-line"></i>
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-link text-info btn-action custom-dropdown-btn"
                                                                        type="button"
                                                                        title="Download"
                                                                        rel="tooltip"
                                                                        onClick={() => handleDownloadPDF(item)}
                                                                    >
                                                                        <i className="ri-download-2-line"></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="container-fluid">
                                    <div className="row border-top pt-3">
                                        <div className="col-auto">
                                            <p className="mt-1 mb-0">Records</p>
                                        </div>
                                        <div className="col-1.2 record-drop">
                                            <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="15">15</option>
                                                <option value="20">20</option>
                                                <option value="25">25</option>
                                            </select>
                                        </div>
                                        <div className="col">
                                            <nav>
                                                <ul className="pagination justify-content-center">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                            <i className="ri-arrow-left-double-line"></i>
                                                        </button>
                                                    </li>
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                            <i className="ri-arrow-left-s-line"></i>
                                                        </button>
                                                    </li>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                            <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                {index + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                            <i className="ri-arrow-right-s-line"></i>
                                                        </button>
                                                    </li>
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <button className="page-link" onClick={() => paginate(totalPages)}>
                                                            <i className="ri-arrow-right-double-fill"></i>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div className="col-auto">
                                            <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/*View Modal */}
            {modalData && (
                <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block', textAlign: 'center' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header py-2">
                                <h6 className="modal-title">Request Status Details</h6>
                                <button className="close" type="button" onClick={() => setModalData(null)}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body py-0">
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Request ID</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.requestId} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Employee ID</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.employeeId} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Employee Name</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.employeeName} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Category</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.category} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Sub Category</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.subCategory} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Department</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.department} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Request Date</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={moment(modalData.requestedDate).format("DD-MM-YYYY")} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Assigned To</small>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" className="form-control-plaintext" value={modalData.assignTo} readOnly />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-0 text-right">Status</small>
                                    </div>
                                    <div className="col-1">
                                        <span>
                                            {modalData.status.trim().toLowerCase() === 'approved' ? (
                                                <span className="badge border border-success text-success status">
                                                    <i className="ri-verified-badge-fill"></i> {modalData.status}
                                                </span>
                                            ) : modalData.status.trim().toLowerCase() === 'inprogress' ? (
                                                <span className="badge border border-warning text-warning status">
                                                    <i className="ri-hourglass-fill"></i> {modalData.status}
                                                </span>
                                            ) : (
                                                <span className="badge border border-secondary text-secondary status">
                                                    <i className="ri-question-mark"></i> {modalData.status}
                                                </span>
                                            )}
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Description</small>
                                    </div>
                                    <div className="col-9">
                                        <textarea className="form-control-plaintext" readOnly>{modalData.description}</textarea>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Comments</small>
                                    </div>
                                    <div className="col-9">
                                        <textarea className="form-control-plaintext" readOnly>{modalData.comments}</textarea>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <small className="form-text text-muted mt-2 text-right">Documents</small>
                                    </div>
                                    <div className="col-9">
                                        <div className="row drop-down-scroll">
                                            {modalData?.SupportRequestDocuments?.map((document, index) => {
                                                const fileName = document.Documents.split('/').pop();
                                                const truncatedFileName = fileName.length > 15 ? fileName.substring(0, 12) + '...' : fileName;

                                                return (
                                                    <div className="col-6 mb-2" key={index}>
                                                        <div className="d-flex align-items-center">
                                                            <i className="ri-eye-line"></i>
                                                            <a href={document.Documents}
                                                                className="ml-2"
                                                                title={fileName}
                                                                style={{ maxWidth: '150px' }}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {truncatedFileName}
                                                            </a>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/*Update Modal */}
            {updateModalData && (
                <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block', textAlign: 'center' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="updateModalLabel">Record -{updateModalData.requestId}</h6>
                                <button className="close" type="button" onClick={() => closeModal()} aria-label="Close">
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-8 border-right">
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Request ID</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.requestId} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Employee ID</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.employeeId} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Employee Name</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.employeeName} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Category</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.category} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Sub Category</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.subCategory} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Department</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.department} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Request Date</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={moment(updateModalData.requestedDate).format("DD-MM-YYYY")} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Assigned To</small>
                                            </div>
                                            <div className="col-9">
                                                <input type="text" className="form-control-plaintext" value={updateModalData.assignTo} readOnly />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-0 text-right">Status</small>
                                            </div>
                                            <div className="col-1">
                                                <span><span className="badge border border-warning text-warning status"><i className="ri-verified-badge-fill"></i> {updateModalData.status}</span></span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Description</small>
                                            </div>
                                            <div className="col-6">
                                                <textarea className="form-control-plaintext" readOnly>{updateModalData.description}</textarea>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Comments</small>
                                            </div>
                                            <div className="col-6">
                                                <textarea className="form-control-plaintext" readOnly>{updateModalData.comments}</textarea>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <small className="form-text text-muted mt-2 text-right">Documents</small>
                                            </div>
                                            <div className="col-3">
                                                <div className="row drop-down-scroll">
                                                    {updateModalData?.SupportRequestDocuments?.map((document, index) => {
                                                        const fileName = document.Documents.split('/').pop();
                                                        const truncatedFileName = fileName.length > 15 ? fileName.substring(0, 12) + '...' : fileName;

                                                        return (
                                                            <div className="col-6 mb-2" key={index}>
                                                                <div className="d-flex align-items-center">
                                                                    <i className="ri-eye-line"></i>
                                                                    <a href={document.Documents}
                                                                        className="ml-2 text-truncate"
                                                                        title={fileName}
                                                                        style={{ maxWidth: '150px' }}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {truncatedFileName}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="container-fluid scroll-form">
                                            <h6>Action Required</h6>
                                            <hr />
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="requestAssignTo" className="required">Assign To</label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="AssignTo"
                                                            value={assignToOptions?.find(option => option.value === updateData.AssignTo) || null}
                                                            onChange={(selectedOption) =>
                                                                setUpdateData({
                                                                    ...updateData,
                                                                    AssignTo: selectedOption ? selectedOption.value : '',
                                                                })
                                                            }
                                                            options={assignToOptions}
                                                            placeholder="select..."
                                                            isClearable
                                                            components={{ ClearIndicator }} // if you want to customize components
                                                            menuPortalTarget={document.body} // for positioning the menu
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="Document">
                                                            Document
                                                        </label>
                                                        <div className="d-flex align-items-center">
                                                            <div className="custom-file mr-2">
                                                                <input
                                                                    type="file"
                                                                    className="custom-file-input"
                                                                    id="Document"
                                                                    placeholder='Choose File'
                                                                    onChange={handleFileChange}
                                                                />
                                                                <label className="custom-file-label" htmlFor="uploadEmpofferletter">
                                                                    {file ? file.name : null}
                                                                </label>
                                                            </div>
                                                            <button className="btn btn-secondary" onClick={handleUpload}>
                                                                Upload
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="container-fluid my-2 px-0">
                                                        <div className="row">
                                                            {uploadedFiles?.map((file, index) => (
                                                                <div key={index} className="col-6 mb-2">
                                                                    <button
                                                                        className="btn btn-link text-danger btn-action"
                                                                        type="button"
                                                                        onClick={() => handleDelete(index)}
                                                                    >
                                                                        <i className="ri-delete-bin-6-line" />
                                                                    </button>
                                                                    <a href="#" onClick={() => window.open(URL.createObjectURL(file), '_blank')}>
                                                                        {file.name}
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="notifyComments">Comments</label>
                                                    <textarea className="form-control" rows="5" value={updateData.Comments} onChange={handleUpdateChange('Comments')}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer py-2 justify-content-center">
                                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Submit <i className="ri-checkbox-circle-line"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};


export default RequestStatus;
